import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { useCreateApiKey } from '../api';
import { apiKeyFormSchema, type ApiKeyFormInput } from '../schema';
import { ApiKeyForm } from './ApiKeyForm';

export function CreateApiKeyPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const create = useCreateApiKey();

  const form = useForm<ApiKeyFormInput>({
    resolver: zodResolver(apiKeyFormSchema),
    mode: 'onTouched',
    defaultValues: { secretKey: '', ip: '', apikey: '' },
  });

  const onSubmit = (input: ApiKeyFormInput) => {
    create.mutate(
      {
        ip: input.ip.trim(),
        apikey: input.apikey,
        userId: Number(userId),
        secretKey: input.secretKey,
      },
      {
        onSuccess: (res) => {
          if (res?.message === 'Parameters Incorrect') {
            toast.error(res.message);
            return;
          }
          toast.success(res?.message ?? 'API key created');
          navigate('/user-api-key-list');
        },
        onError: () => toast.error('Could not create the API key.'),
      },
    );
  };

  return (
    <ApiKeyForm mode="create" form={form} onSubmit={onSubmit} isPending={create.isPending} />
  );
}
